import React from "react";
import { Alert } from "@material-ui/lab";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { StyledCol, StyledTable, StyledTableBody, StyledTableHead, StyledTableRow } from "../../styles/styledTable";

const RatesLst = ({ rates }) => {
  const { t } = useTranslation("ratesPage");

  if (!rates) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (rates.length === 0) {
    return <Alert severity="warning">{t("rates.table.emptyData")}</Alert>;
  }

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <StyledTable
      className="rates-table"
      size="14"
    >
      <StyledTableHead
        className="rates-table__head"
        scroll="auto"
        col="7"
      >
        <div className="rates-table__col rates-table_col-fixed">
          {t("rates.table.currency")}
        </div>
        <div className="rates-table__col">
          {t("rates.table.service")}
        </div>
        <div className="rates-table__col">
          {t("rates.table.rateSelling")}
        </div>
        <div className="rates-table__col">
          {t("rates.table.ratePurchase")}
        </div>
        <div className="rates-table__col">
          {t("rates.table.selling")}
        </div>
        <div className="rates-table__col">
          {t("rates.table.purchase")}
        </div>
        <div className="rates-table__col">
          {t("rates.table.action")}
        </div>
      </StyledTableHead>
      <StyledTableBody>
        {rates && rates.map((value, key) => (
          <StyledTableRow
            className="rates-table__row"
            key={key}
            scroll="auto"
            col="7"
            onClick={(e) => {showDetails(e);}}
            cursor="pointer"
            as={NavLink}
            to={`/rates/${value.id}`}
          >
            <StyledCol data-title={t("rates.table.currency")} className="rates-table__col rates-table_col-fixed">
              {value.currency.asset}
            </StyledCol>
            <StyledCol data-title={t("rates.table.service")} className="rates-table__col">
              {getServiceNameWithNickname(value.service.name, value.service.nickname)}
            </StyledCol>
            <StyledCol data-title={t("rates.table.rateSelling")} className="rates-table__col">
              {value.rateSelling}
            </StyledCol>
            <StyledCol data-title={t("rates.table.ratePurchase")} className="rates-table__col">
              {value.ratePurchase}
            </StyledCol>
            <StyledCol data-title={t("rates.table.selling")} className="rates-table__col">
              {value.selling}
            </StyledCol>
            <StyledCol data-title={t("rates.table.purchase")} className="rates-table__col">
              {value.purchase}
            </StyledCol>
            <StyledCol inline data-title={t("rates.table.action")} className="rates-table__col">
              <NavLink
                className="table-action table-action_info"
                to={"/rates/" + value.id}
              >
                <span className="icon-light-edit" />
                {t("rates.table.edit")}
              </NavLink>
            </StyledCol>
          </StyledTableRow>
        ))}
      </StyledTableBody>
    </StyledTable>
  );
};
export default RatesLst;